var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGasStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "local_gas_station"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_1106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_gas_station_2",
    d: "M4.5 19.596V5.30775C4.5 4.80258 4.675 4.375 5.025 4.025C5.375 3.675 5.80258 3.5 6.30775 3.5H11.6923C12.1974 3.5 12.625 3.675 12.975 4.025C13.325 4.375 13.5 4.80258 13.5 5.30775V11.8077H14.4615C14.9587 11.8077 15.3843 11.9847 15.7383 12.3387C16.0923 12.6927 16.2693 13.1182 16.2693 13.6152V18.1538C16.2693 18.4756 16.3811 18.7483 16.6048 18.972C16.8284 19.1958 17.1012 19.3077 17.423 19.3077C17.7448 19.3077 18.0176 19.1958 18.2413 18.972C18.4651 18.7483 18.577 18.4756 18.577 18.1538V11.1462C18.427 11.2359 18.2687 11.2981 18.102 11.3327C17.9353 11.3672 17.7603 11.3845 17.577 11.3845C16.9632 11.3845 16.4443 11.1726 16.0203 10.7487C15.5964 10.3249 15.3845 9.80608 15.3845 9.19225C15.3845 8.69742 15.5256 8.25675 15.8077 7.87025C16.0897 7.48375 16.4628 7.22442 16.927 7.09225L15.0922 5.25775C14.9742 5.13975 14.9137 5.00158 14.9105 4.84325C14.9073 4.68492 14.9688 4.54267 15.095 4.4165C15.2073 4.30417 15.3436 4.2455 15.5038 4.2405C15.6641 4.23533 15.8064 4.28983 15.9307 4.404L19.0768 7.504C19.3013 7.72833 19.4728 7.98825 19.5913 8.28375C19.7099 8.57925 19.7693 8.88208 19.7693 9.19225V18.1538C19.7693 18.8108 19.5426 19.366 19.0893 19.8195C18.6361 20.2732 18.0813 20.5 17.425 20.5C16.7685 20.5 16.213 20.2732 15.7585 19.8195C15.3042 19.366 15.077 18.8108 15.077 18.1538V13.3077C15.077 13.2179 15.0481 13.1442 14.9902 13.0865C14.9326 13.0288 14.8589 13 14.7693 13H13.5V19.596C13.5 19.8522 13.4138 20.0668 13.2413 20.24C13.0688 20.4133 12.855 20.5 12.6 20.5H5.39975C5.14475 20.5 4.93108 20.4133 4.75875 20.24C4.58625 20.0668 4.5 19.8522 4.5 19.596ZM6 10.25H12V5.30775C12 5.23075 11.9679 5.16025 11.9037 5.09625C11.8397 5.03208 11.7693 5 11.6923 5H6.30775C6.23075 5 6.16025 5.03208 6.09625 5.09625C6.03208 5.16025 6 5.23075 6 5.30775V10.25ZM17.577 10.1923C17.8603 10.1923 18.0978 10.0964 18.2895 9.90475C18.4812 9.71308 18.577 9.47558 18.577 9.19225C18.577 8.90892 18.4812 8.67142 18.2895 8.47975C18.0978 8.28808 17.8603 8.19225 17.577 8.19225C17.2937 8.19225 17.0562 8.28808 16.8645 8.47975C16.6728 8.67142 16.577 8.90892 16.577 9.19225C16.577 9.47558 16.6728 9.71308 16.8645 9.90475C17.0562 10.0964 17.2937 10.1923 17.577 10.1923ZM6 19H12V11.75H6V19Z",
    fill: "var(--fill-0, white)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGasStation);
export default __webpack_public_path__ + "static/media/icon-gas-station.6c98c0eb24e8bd8d12fd267158bc7acf.svg";
export { ForwardRef as ReactComponent };